import React, {PropsWithChildren, ReactElement} from 'react';

import Col from '../../../common/Col';

type Props = PropsWithChildren<{
  title: string;
}>;

const SimpleCalculatorCard = ({title, children}: Props): ReactElement => {
  return (
    <Col className={'border-thin border-gray-100 rounded-3xl px-xl mobile:px-sm py-md gap-sm'}>
      <h1 className={'text-center'}>{title}</h1>
      {children}
    </Col>
  );
};

export default SimpleCalculatorCard;
